module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/vocabulary/components/duplication-found.component.scss
// module id = ./src/app/vocabulary/components/duplication-found.component.scss
// module chunks = main